export const DEFAULT_CAMERA_IMAGE_QUALITY = 85;
